import { render, staticRenderFns } from "./VAnnotation.vue?vue&type=template&id=0bdeeffe&scoped=true&"
import script from "./VAnnotation.vue?vue&type=script&lang=js&"
export * from "./VAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./VAnnotation.vue?vue&type=style&index=0&id=0bdeeffe&lang=scss&scoped=true&"
import style1 from "./VAnnotation.vue?vue&type=style&index=1&id=0bdeeffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdeeffe",
  null
  
)

export default component.exports